module.exports = __webpack_public_path__ + "media/נר.b46dabdf.mp3";